export function formatPatientName(patient, format) {
  if (!patient) return 'Patient';
  const first = patient.first_name || '';
  const last = patient.last_name || '';
  const mi = patient.middle_name ? ` ${patient.middle_name[0]}.` : '';
  if (!first && !last) return 'Patient';
  if (format === 'last_first') {
    return `${last}, ${first}${mi}`.replace(/^, /, '');
  }
  return `${first}${mi} ${last}`.trim();
}
